<div class="horizontalMenuBar flex-container" style="z-index:9999;">
    <a routerLink="/"><img src="/assets/images/SantosWeb.png" id="hidelogo"
            style="display: inline-flex;justify-content: center;vertical-align: middle;height: 20px !important;margin: 10px !important;" /></a>
    <div class="toptext2">{{[(title)]}} <span *ngIf="this.settings.configuration.envName != 'prod'"> (TEST)</span></div>

    <div>
        <div style="height:auto;">
            
            <button kendoButton *ngIf="!userProfilePic" [icon]="'user'" [look]="'outline'" (click)="this.dialogUser('open')"
                style="margin-right:10px;color:white;margin-top:10px;margin-bottom: 8px;height: 42px;">{{globals.user.name}}</button>
            <button kendoButton *ngIf="userProfilePic" [imageUrl]="userProfilePic" class="user-profile-pic" [look]="'outline'" (click)="this.dialogUser('open')"
                style="margin-right:10px;color:white;margin-top:10px;margin-bottom: 8px;height: 42px;">{{globals.user.name}}</button>
            <button kendoButton [look]="'outline'" (click)="logOut()"
                style="margin-right:10px;color:white;margin-top:10px;margin-bottom: 8px;height: 42px;">Log Out</button>
        </div>
    </div>
</div>

<div class="example-wrapper">
    <kendo-dialog title="Information" *ngIf="dialogOpenedUser" (close)="dialogUser('close')" [minWidth]="300">
        <fieldset>
            <div class="row">
                <div class="col-sm-6">
                    <label class="k-form-field">
                        <b>Unique ID:</b>
                    </label>
                </div>
                <div class="col-sm-6">
                    <label class="k-form-field">
                        {{globals.user.username}}
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <label class="k-form-field">
                        <b>Name:</b>
                    </label>
                </div>
                <div class="col-sm-6">
                    <label class="k-form-field">
                        {{globals.user.name}}
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <label class="k-form-field">
                        <b>Manifest version:</b>
                    </label>
                </div>
                <div class="col-sm-6">
                    <label class="k-form-field">
                        {{appName}} ({{globals.version}})
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <label class="k-form-field">
                        <b>Device:</b>
                    </label>
                </div>
                <div class="col-sm-6">
                    <label class="k-form-field">
                        {{globals.device}}
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <label class="k-form-field">
                        <b>Saved to home screen:</b>
                    </label>
                </div>
                <div class="col-sm-6">
                    <label class="k-form-field">
                        <p *ngIf="globals.isInstalled">Yes</p>
                        <p *ngIf="!globals.isInstalled">No</p>
                    </label>
                </div>
            </div>
        </fieldset>

        <kendo-dialog-actions>
            <button kendoButton (click)="dialogUser('close')" primary="true">OK</button>
        </kendo-dialog-actions>
    </kendo-dialog>
</div>